import { ILoginFlows } from "../entities/CommonLoginData";
var validateMPINMapper = function (data) {
    if (data) {
        return {
            daysLeft: data.daysLeft,
            status: true,
            userType: ILoginFlows.GUEST,
            guestId: data.unId,
            message: data.msg,
            registeredDate: data.regDt,
            mobileNo: data.mobileNo,
            name: data.name,
        };
    }
    return {};
};
export default validateMPINMapper;
